import { ModelSetTransformer, ModelTransformer } from '../common/common.model';

export interface Args<T = any> {
    args?: T;
}

export interface Data<T = any, U = any> extends Args<U> {
    dataId?: number;
    payload: T;
    templateId: number;
}

export class DataModelTransformer<T, U = T>
    implements ModelTransformer<Data<T>, Data<U>>
{
    constructor(
        private readonly _payloadTransformer?: ModelTransformer<T, U>,
    ) {}

    transform(model: Data<U>): Data<T> {
        const transformed = { ...model } as any as Data<T>;
        if (this._payloadTransformer) {
            transformed.payload = this._payloadTransformer.transform(
                model.payload,
            );
        }
        return transformed;
    }

    reverseTransform(model: Data<T>): Data<U> {
        const transformed = { ...model } as any as Data<U>;
        if (this._payloadTransformer) {
            transformed.payload = this._payloadTransformer.reverseTransform(
                model.payload,
            );
        }
        return transformed;
    }
}

export class DataModelSetTransformer<T, U = T> extends ModelSetTransformer<
    Data<T>,
    Data<U>
> {
    constructor(private readonly _payloadTransformer?: ModelTransformer<T, U>) {
        super();
    }

    protected newTransformer(): ModelTransformer<Data<T>, Data<U>> {
        return new DataModelTransformer(this._payloadTransformer);
    }
}
